import { useState, useEffect } from 'react';

export const useOgImage = (url: string): { imageUrl: string | null; loading: boolean } => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!url) {
      setLoading(false);
      return;
    }

    // Para Vite, simplemente retornamos null ya que no tenemos API server
    setLoading(false);
    setImageUrl(null);
  }, [url]);

  return { imageUrl, loading };
};
